import React from "react";

export function ProfileFeedback () {
    
    return (<>
    <div>ProfileFeedback</div>
    </>);

}